"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCodesMobileCont = exports.CountryCodesList = exports.FieldCont = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.FieldCont = styled_components_1.default.div `
  :last-child {
    margin-bottom: 0 !important;
  }
  .fieldDet {
    padding: 0 16px;
  }
  .hasError {
    border: 1px solid var(--red) !important;
  }
  .countryCode {
    border-right: 1px solid #dcdcdc;
    width: 99px;
  }
  .iconClear,
  .iconEye {
    padding: 5px;
  }
`;
exports.CountryCodesList = styled_components_1.default.ul `
  top: 107%;
  left: 0;
  max-height: 300px;
  z-index: 2;
  li:last-child {
    border-bottom: 0;
  }
`;
exports.CountryCodesMobileCont = styled_components_1.default.div `
  .iconClose {
    padding: 5px;
  }
`;
